export default {
  titleMaintenance: 'Wartungsarbeiten',
  titleDisturbance: 'Technische Störung',
  backSoon: 'Wir werden bald zurück sein!',
  infoMaintenance:
    'Entschuldigen Sie die Unannehmlichkeiten, aber wir führen derzeit einige Wartungsarbeiten durch.<br /><br />Wenn Sie dieses Fenster für eine Weile geöffnet hatten, versuchen Sie bitte, die Seite zu aktualisieren. Möglicherweise sind wir bereits fertig.',
  infoDisturbance:
    'Entschuldigen Sie die Unannehmlichkeiten, aber derzeit liegt eine technische Störung unseres Systems vor. Wir arbeiten an einer Behebung der Störung.<br /><br />Wenn Sie dieses Fenster für eine Weile geöffnet hatten, versuchen Sie bitte, die Seite zu aktualisieren. Möglicherweise sind wir bereits fertig.'
};
